{
    "version": 8,
    "name": "FE-Dark2",
    "metadata": {
        "mapbox:autocomposite": false,
        "mapbox:groups": {
            "101da9f13b64a08fa4b6ac1168e89e5f": {
                "collapsed": false,
                "name": "Places"
            },
            "a14c9607bc7954ba1df7205bf660433f": { "name": "Boundaries" },
            "b6371a3f2f5a9932464fa3867530a2e5": {
                "collapsed": false,
                "name": "Transportation"
            }
        },
        "maputnik:renderer": "mlgljs"
    },
    "sources": {
        "febase": {
            "type": "vector",
            "tiles": ["https://dhpfl5h9i14m7.cloudfront.net/FEBase-A-YYYYMMDD/{z}/{x}/{y}.mvt"],
            "minzoom": 0,
            "maxzoom": 14,
            "attribution": "<a target='_blank' href='https://openstreetmap.org/copyright'>OpenStreetMap</a>"
        },
        "terrain_source": {
            "type": "raster-dem",
            "encoding": "terrarium",
            "tiles": ["https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png"],
            "tileSize": 256,
            "minzoom": 0,
            "maxzoom": 14
        }
    },
    "sprite": [
        {
            "id": "fe",
            "url": "static/map/CAEFESprite"
        }
    ],
    "sky": {
        "sky-color": "#88C6FC",
        "sky-horizon-blend": 0.8,
        "horizon-color": "#ffffff",
        "horizon-fog-blend": 0.8,
        "fog-color": "#ffffff",
        "fog-ground-blend": 0.5,
        "atmosphere-blend": 0
    },
    "light": {
        "anchor": "viewport",
        "position": [0, 210, 30],
        "color": "#ffffff",
        "intensity": 0
    },
    "state": {
        "text-color": { "default": "white" },
        "feNav_icon-color": { "default": "rgba(100,100,100,1)" },
        "feNav_text-color": { "default": "rgba(100,100,100,1)" },
        "feNav_line-color": { "default": "rgba(100,100,100,1)" },
        "feNav_icon-color_awy_def": { "default": "rgba(100,100,100,1)" },
        "feNav_line-color_awy_def": { "default": "rgba(100,100,100,1)" },
        "feNav_text-color_awyl": { "default": "rgba(200,200,200,1)" },
        "feNav_line-color_mor": { "default": "rgb(140,140,140)" },
        "feNav_line-color_overwater": { "default": "rgba(65,105,225,0.7)" },
        "feNav_text-color_mor_def": { "default": "rgba(0,170,0,1)" },
        "feNav_text-color_aspl": { "default": "rgb(150,150,150)" },
        "feNav_text-color_sual": { "default": "rgb(120,120,120)" },
        "feNav_text-color_hldl": { "default": "rgb(160,160,160)" }
    },
    "layers": [
        {
            "id": "background",
            "type": "background",
            "paint": { "background-color": "rgb(12,12,12)" }
        },
        {
            "id": "water",
            "type": "fill",
            "source": "febase",
            "source-layer": "water",
            "minzoom": 0,
            "filter": ["all", ["==", "$type", "Polygon"], ["!=", "brunnel", "tunnel"]],
            "layout": { "visibility": "visible" },
            "paint": { "fill-antialias": false, "fill-color": "rgb(27 ,27 ,29)" }
        },
        {
            "id": "landcover_ice_shelf",
            "type": "fill",
            "source": "febase",
            "source-layer": "landcover",
            "maxzoom": 8,
            "filter": ["all", ["==", "$type", "Polygon"], ["==", "subclass", "ice_shelf"]],
            "layout": { "visibility": "visible" },
            "paint": { "fill-color": "rgb(12,12,12)", "fill-opacity": 0.7 }
        },
        {
            "id": "landcover_glacier",
            "type": "fill",
            "source": "febase",
            "source-layer": "landcover",
            "maxzoom": 8,
            "filter": ["all", ["==", "$type", "Polygon"], ["==", "subclass", "glacier"]],
            "layout": { "visibility": "visible" },
            "paint": {
                "fill-color": "hsl(0, 1%, 2%)",
                "fill-opacity": {
                    "base": 1,
                    "stops": [
                        [0, 1],
                        [8, 0.5]
                    ]
                }
            }
        },
        {
            "id": "landuse_residential",
            "type": "fill",
            "source": "febase",
            "source-layer": "landuse",
            "maxzoom": 9,
            "filter": ["all", ["==", "$type", "Polygon"], ["==", "class", "residential"]],
            "layout": { "visibility": "none" },
            "paint": { "fill-color": "hsl(0, 2%, 5%)", "fill-opacity": 0.4 }
        },
        {
            "id": "landcover_wood",
            "type": "fill",
            "source": "febase",
            "source-layer": "landcover",
            "minzoom": 10,
            "filter": ["all", ["==", "$type", "Polygon"], ["==", "class", "wood"]],
            "layout": { "visibility": "none" },
            "paint": {
                "fill-color": "rgb(32,32,32)",
                "fill-opacity": {
                    "base": 0.3,
                    "stops": [
                        [8, 0],
                        [10, 0.8],
                        [13, 0.4]
                    ]
                },
                "fill-pattern": "fe:wood-pattern",
                "fill-translate": [0, 0]
            }
        },
        {
            "id": "landuse_park",
            "type": "fill",
            "source": "febase",
            "source-layer": "landuse",
            "filter": ["all", ["==", "$type", "Polygon"], ["==", "class", "park"]],
            "layout": { "visibility": "none" },
            "paint": { "fill-color": "rgb(32,32,32)" }
        },
        {
            "id": "waterway",
            "type": "line",
            "source": "febase",
            "source-layer": "waterway",
            "minzoom": 7,
            "filter": ["==", "$type", "LineString"],
            "layout": { "visibility": "visible" },
            "paint": { "line-color": "rgb(27 ,27 ,29)" }
        },
        {
            "id": "water_name",
            "type": "symbol",
            "source": "febase",
            "source-layer": "water_name",
            "filter": ["==", "$type", "LineString"],
            "layout": {
                "symbol-placement": "line",
                "symbol-spacing": 500,
                "text-field": "{name:latin}\n{name:nonlatin}",
                "text-font": ["Metropolis Medium Italic"],
                "text-rotation-alignment": "map",
                "text-size": 12
            },
            "paint": {
                "text-color": "hsla(0, 0%, 0%, 0.7)",
                "text-halo-color": "hsl(0, 0%, 27%)"
            }
        },
        {
            "id": "building",
            "type": "fill",
            "source": "febase",
            "source-layer": "building",
            "minzoom": 12,
            "filter": ["==", "$type", "Polygon"],
            "paint": {
                "fill-antialias": true,
                "fill-color": "rgb(10,10,10)",
                "fill-outline-color": "rgb(27 ,27 ,29)"
            }
        },
        {
            "id": "aeroway-taxiway",
            "type": "line",
            "metadata": { "mapbox:group": "1444849345966.4436" },
            "source": "febase",
            "source-layer": "aeroway",
            "minzoom": 12,
            "filter": ["all", ["in", "class", "taxiway"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                "visibility": "visible"
            },
            "paint": {
                "line-color": "#181818",
                "line-opacity": 1,
                "line-width": {
                    "base": 1.55,
                    "stops": [
                        [13, 1.8],
                        [20, 20]
                    ]
                }
            }
        },
        {
            "id": "aeroway-runway-casing",
            "type": "line",
            "metadata": { "mapbox:group": "1444849345966.4436" },
            "source": "febase",
            "source-layer": "aeroway",
            "minzoom": 11,
            "filter": ["all", ["in", "class", "runway"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                "visibility": "visible"
            },
            "paint": {
                "line-color": "rgba(60,60,60,0.8)",
                "line-opacity": 1,
                "line-width": {
                    "base": 1.5,
                    "stops": [
                        [11, 5],
                        [17, 55]
                    ]
                }
            }
        },
        {
            "id": "aeroway-area",
            "type": "fill",
            "metadata": { "mapbox:group": "1444849345966.4436" },
            "source": "febase",
            "source-layer": "aeroway",
            "minzoom": 4,
            "filter": ["all", ["==", "$type", "Polygon"], ["in", "class", "runway", "taxiway"]],
            "layout": { "visibility": "visible" },
            "paint": { "fill-color": "#000", "fill-opacity": 1 }
        },
        {
            "id": "aeroway-runway",
            "type": "line",
            "metadata": { "mapbox:group": "1444849345966.4436" },
            "source": "febase",
            "source-layer": "aeroway",
            "minzoom": 11,
            "filter": ["all", ["in", "class", "runway"], ["==", "$type", "LineString"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                "visibility": "visible"
            },
            "paint": {
                "line-color": "#000",
                "line-opacity": 1,
                "line-width": {
                    "base": 1.5,
                    "stops": [
                        [11, 4],
                        [17, 50]
                    ]
                }
            }
        },
        {
            "id": "road_area_pier",
            "type": "fill",
            "metadata": {},
            "source": "febase",
            "source-layer": "transportation",
            "filter": ["all", ["==", "$type", "Polygon"], ["==", "class", "pier"]],
            "layout": { "visibility": "visible" },
            "paint": { "fill-antialias": true, "fill-color": "rgb(12,12,12)" }
        },
        {
            "id": "road_pier",
            "type": "line",
            "metadata": {},
            "source": "febase",
            "source-layer": "transportation",
            "filter": ["all", ["==", "$type", "LineString"], ["in", "class", "pier"]],
            "layout": { "line-cap": "round", "line-join": "round" },
            "paint": {
                "line-color": "rgb(12,12,12)",
                "line-width": {
                    "base": 1.2,
                    "stops": [
                        [15, 1],
                        [17, 4]
                    ]
                }
            }
        },
        {
            "id": "highway_path",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 0,
            "filter": ["all", ["==", "$type", "LineString"], ["==", "class", "path"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                "visibility": "visible"
            },
            "paint": {
                "line-color": "rgb(27 ,27 ,29)",
                "line-dasharray": [1.5, 1.5],
                "line-opacity": 0.9,
                "line-width": {
                    "base": 1.2,
                    "stops": [
                        [13, 1],
                        [20, 10]
                    ]
                }
            }
        },
        {
            "id": "highway_minor",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 8,
            "filter": ["all", ["==", "$type", "LineString"], ["in", "class", "minor", "service", "track"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                "visibility": "visible"
            },
            "paint": {
                "line-color": "#181818",
                "line-opacity": 0.9,
                "line-width": {
                    "base": 1.55,
                    "stops": [
                        [13, 1.8],
                        [20, 20]
                    ]
                }
            }
        },
        {
            "id": "highway_major_casing",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 11,
            "filter": ["all", ["==", "$type", "LineString"], ["in", "class", "primary", "secondary", "tertiary", "trunk"]],
            "layout": {
                "line-cap": "butt",
                "line-join": "miter",
                "visibility": "visible"
            },
            "paint": {
                "line-color": "rgba(60,60,60,0.8)",
                "line-dasharray": [12, 0],
                "line-width": {
                    "base": 1.3,
                    "stops": [
                        [10, 3],
                        [20, 23]
                    ]
                }
            }
        },
        {
            "id": "highway_major_inner",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 11,
            "filter": ["all", ["==", "$type", "LineString"], ["in", "class", "primary", "secondary", "tertiary", "trunk"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                "visibility": "visible"
            },
            "paint": {
                "line-color": "hsl(0, 0%, 7%)",
                "line-width": {
                    "base": 1.3,
                    "stops": [
                        [10, 2],
                        [20, 20]
                    ]
                }
            }
        },
        {
            "id": "highway_major_subtle",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 0,
            "maxzoom": 11,
            "filter": ["all", ["==", "$type", "LineString"], ["in", "class", "primary", "secondary", "tertiary", "trunk"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                "visibility": "none"
            },
            "paint": {
                "line-color": "#2a2a2a",
                "line-width": {
                    "stops": [
                        [6, 0],
                        [8, 2]
                    ]
                }
            }
        },
        {
            "id": "highway_motorway_casing",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 8,
            "filter": ["all", ["==", "$type", "LineString"], ["==", "class", "motorway"]],
            "layout": {
                "line-cap": "butt",
                "line-join": "miter",
                "visibility": "visible"
            },
            "paint": {
                "line-color": "rgba(60,60,60,0.8)",
                "line-dasharray": [2, 0],
                "line-opacity": 1,
                "line-width": {
                    "base": 1.4,
                    "stops": [
                        [5.8, 0],
                        [6, 3],
                        [20, 40]
                    ]
                }
            }
        },
        {
            "id": "highway_motorway_inner",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 8,
            "filter": ["all", ["==", "$type", "LineString"], ["==", "class", "motorway"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                "visibility": "visible"
            },
            "paint": {
                "line-color": {
                    "base": 1,
                    "stops": [
                        [5.8, "hsla(0, 0%, 85%, 0.53)"],
                        [6, "#000"]
                    ]
                },
                "line-width": {
                    "base": 1.4,
                    "stops": [
                        [4, 2],
                        [6, 1.3],
                        [20, 30]
                    ]
                }
            }
        },
        {
            "id": "road_oneway",
            "type": "symbol",
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 15,
            "filter": ["all", ["==", "oneway", 1]],
            "layout": {
                "symbol-placement": "line",
                "icon-image": "fe:oneway",
                "symbol-spacing": 200,
                "icon-padding": 2,
                "icon-rotation-alignment": "map",
                "icon-rotate": 0,
                "icon-size": {
                    "stops": [
                        [15, 0.5],
                        [19, 1]
                    ]
                }
            },
            "paint": { "icon-opacity": 0.5 }
        },
        {
            "id": "road_oneway_opposite",
            "type": "symbol",
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 15,
            "filter": ["all", ["==", "oneway", -1]],
            "layout": {
                "symbol-placement": "line",
                "icon-image": "fe:oneway",
                "symbol-spacing": 200,
                "icon-padding": 2,
                "icon-rotation-alignment": "map",
                "icon-rotate": 180,
                "icon-size": {
                    "stops": [
                        [15, 0.5],
                        [19, 1]
                    ]
                }
            },
            "paint": { "icon-opacity": 0.5 }
        },
        {
            "id": "highway_motorway_subtle",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "maxzoom": 6,
            "filter": ["all", ["==", "$type", "LineString"], ["==", "class", "motorway"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                "visibility": "none"
            },
            "paint": {
                "line-color": "#181818",
                "line-width": {
                    "base": 1.4,
                    "stops": [
                        [4, 2],
                        [6, 1.3]
                    ]
                }
            }
        },
        {
            "id": "railway_transit",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 16,
            "filter": ["all", ["==", "$type", "LineString"], ["all", ["==", "class", "transit"], ["!in", "brunnel", "tunnel"]]],
            "layout": { "line-join": "round", "visibility": "visible" },
            "paint": { "line-color": "rgb(35,35,35)", "line-width": 3 }
        },
        {
            "id": "railway_transit_dashline",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 16,
            "filter": ["all", ["==", "$type", "LineString"], ["all", ["==", "class", "transit"], ["!in", "brunnel", "tunnel"]]],
            "layout": { "line-join": "round", "visibility": "visible" },
            "paint": {
                "line-color": "rgb(12,12,12)",
                "line-dasharray": [3, 3],
                "line-width": 2
            }
        },
        {
            "id": "railway_minor",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 16,
            "filter": ["all", ["==", "$type", "LineString"], ["all", ["==", "class", "rail"], ["has", "service"]]],
            "layout": { "line-join": "round", "visibility": "visible" },
            "paint": { "line-color": "rgb(35,35,35)", "line-width": 3 }
        },
        {
            "id": "railway_minor_dashline",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 16,
            "filter": ["all", ["==", "$type", "LineString"], ["all", ["==", "class", "rail"], ["has", "service"]]],
            "layout": { "line-join": "round", "visibility": "visible" },
            "paint": {
                "line-color": "rgb(12,12,12)",
                "line-dasharray": [3, 3],
                "line-width": 2
            }
        },
        {
            "id": "railway",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 13,
            "filter": ["all", ["==", "$type", "LineString"], ["==", "class", "rail"], ["!has", "service"]],
            "layout": { "line-join": "round", "visibility": "visible" },
            "paint": {
                "line-color": "rgb(35,35,35)",
                "line-width": {
                    "base": 1.3,
                    "stops": [
                        [16, 3],
                        [20, 7]
                    ]
                }
            }
        },
        {
            "id": "railway_dashline",
            "type": "line",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation",
            "minzoom": 13,
            "filter": ["all", ["==", "$type", "LineString"], ["==", "class", "rail"], ["!has", "service"]],
            "layout": { "line-join": "round", "visibility": "visible" },
            "paint": {
                "line-color": "rgb(12,12,12)",
                "line-dasharray": [3, 3],
                "line-width": {
                    "base": 1.3,
                    "stops": [
                        [16, 2],
                        [20, 6]
                    ]
                }
            }
        },
        {
            "id": "highway_name_other",
            "type": "symbol",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation_name",
            "minzoom": 7,
            "filter": ["all", ["!=", "class", "motorway"], ["==", "$type", "LineString"]],
            "layout": {
                "symbol-placement": "line",
                "symbol-spacing": 350,
                "text-field": "{name:latin} {name:nonlatin}",
                "text-font": ["Metropolis Regular"],
                "text-max-angle": 30,
                "text-pitch-alignment": "viewport",
                "text-rotation-alignment": "map",
                "text-size": 10,
                "text-transform": "uppercase",
                "visibility": "visible"
            },
            "paint": {
                "text-color": "rgba(80, 78, 78, 1)",
                "text-halo-blur": 0,
                "text-halo-color": "rgba(0, 0, 0, 1)",
                "text-halo-width": 1,
                "text-translate": [0, 0]
            }
        },
        {
            "id": "highway_name_motorway",
            "type": "symbol",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "transportation_name",
            "minzoom": 8,
            "filter": ["all", ["==", "$type", "LineString"], ["==", "class", "motorway"]],
            "layout": {
                "symbol-placement": "line",
                "symbol-spacing": 350,
                "text-field": "{ref}",
                "text-font": ["Metropolis Light"],
                "text-pitch-alignment": "viewport",
                "text-rotation-alignment": "viewport",
                "text-size": 10,
                "visibility": "visible"
            },
            "paint": { "text-color": "hsl(0, 0%, 37%)", "text-translate": [0, 2] }
        },
        {
            "id": "boundary_state",
            "type": "line",
            "metadata": { "mapbox:group": "a14c9607bc7954ba1df7205bf660433f" },
            "source": "febase",
            "source-layer": "boundary",
            "minzoom": 2,
            "filter": ["==", "admin_level", 4],
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                "visibility": "visible"
            },
            "paint": {
                "line-blur": 0.4,
                "line-color": "hsl(0, 0%, 21%)",
                "line-dasharray": [2, 2],
                "line-opacity": 1,
                "line-width": {
                    "base": 1.3,
                    "stops": [
                        [3, 1],
                        [22, 15]
                    ]
                }
            }
        },
        {
            "id": "boundary_country_z0-4",
            "type": "line",
            "metadata": { "mapbox:group": "a14c9607bc7954ba1df7205bf660433f" },
            "source": "febase",
            "source-layer": "boundary",
            "maxzoom": 5,
            "filter": ["all", ["==", "admin_level", 2], ["!has", "claimed_by"]],
            "layout": { "line-cap": "round", "line-join": "round" },
            "paint": {
                "line-blur": {
                    "base": 1,
                    "stops": [
                        [0, 0.4],
                        [22, 4]
                    ]
                },
                "line-color": "hsl(0, 0%, 23%)",
                "line-opacity": 1,
                "line-width": {
                    "base": 1.1,
                    "stops": [
                        [3, 1],
                        [22, 20]
                    ]
                }
            }
        },
        {
            "id": "boundary_country_z5-",
            "type": "line",
            "metadata": { "mapbox:group": "a14c9607bc7954ba1df7205bf660433f" },
            "source": "febase",
            "source-layer": "boundary",
            "minzoom": 5,
            "filter": ["==", "admin_level", 2],
            "layout": { "line-cap": "round", "line-join": "round" },
            "paint": {
                "line-blur": {
                    "base": 1,
                    "stops": [
                        [0, 0.4],
                        [22, 4]
                    ]
                },
                "line-color": "hsl(0, 0%, 23%)",
                "line-opacity": 1,
                "line-width": {
                    "base": 1.1,
                    "stops": [
                        [3, 1],
                        [22, 20]
                    ]
                }
            }
        },
        {
            "id": "place_other",
            "type": "symbol",
            "metadata": { "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f" },
            "source": "febase",
            "source-layer": "place",
            "minzoom": 7,
            "maxzoom": 14,
            "filter": ["all", ["==", "$type", "Point"], ["in", "class", "hamlet", "isolated_dwelling", "neighbourhood"]],
            "layout": {
                "text-anchor": "center",
                "text-field": "{name:latin}\n{name:nonlatin}",
                "text-font": ["Metropolis Regular"],
                "text-justify": "center",
                "text-offset": [0.5, 0],
                "text-size": 10,
                "text-transform": "uppercase",
                "visibility": "visible"
            },
            "paint": {
                "text-color": "rgb(101,101,101)",
                "text-halo-blur": 1,
                "text-halo-color": "rgba(0,0,0,0.7)",
                "text-halo-width": 1
            }
        },
        {
            "id": "place_suburb",
            "type": "symbol",
            "metadata": { "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f" },
            "source": "febase",
            "source-layer": "place",
            "minzoom": 8,
            "maxzoom": 15,
            "filter": ["all", ["==", "$type", "Point"], ["==", "class", "suburb"]],
            "layout": {
                "text-anchor": "center",
                "text-field": "{name:latin}\n{name:nonlatin}",
                "text-font": ["Metropolis Regular"],
                "text-justify": "center",
                "text-offset": [0.5, 0],
                "text-size": 10,
                "text-transform": "uppercase",
                "visibility": "visible"
            },
            "paint": {
                "text-color": "rgb(101,101,101)",
                "text-halo-blur": 1,
                "text-halo-color": "rgba(0,0,0,0.7)",
                "text-halo-width": 1
            }
        },
        {
            "id": "place_village",
            "type": "symbol",
            "metadata": { "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f" },
            "source": "febase",
            "source-layer": "place",
            "minzoom": 10,
            "maxzoom": 15,
            "filter": ["all", ["==", "$type", "Point"], ["==", "class", "village"]],
            "layout": {
                "icon-size": 0.4,
                "text-anchor": "left",
                "text-field": "{name:latin}\n{name:nonlatin}",
                "text-font": ["Metropolis Regular"],
                "text-justify": "left",
                "text-offset": [0.5, 0.2],
                "text-size": 10,
                "text-transform": "uppercase",
                "visibility": "visible"
            },
            "paint": {
                "icon-opacity": 0.7,
                "text-color": "rgb(101,101,101)",
                "text-halo-blur": 1,
                "text-halo-color": "rgba(0,0,0,0.7)",
                "text-halo-width": 1
            }
        },
        {
            "id": "place_town",
            "type": "symbol",
            "metadata": { "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f" },
            "source": "febase",
            "source-layer": "place",
            "minzoom": 9,
            "maxzoom": 15,
            "filter": ["all", ["==", "$type", "Point"], ["==", "class", "town"]],
            "layout": {
                "icon-image": {
                    "base": 1,
                    "stops": [
                        [0, "fe:circle-11"],
                        [9, ""]
                    ]
                },
                "icon-size": 0.4,
                "text-anchor": {
                    "base": 1,
                    "stops": [
                        [0, "left"],
                        [8, "center"]
                    ]
                },
                "text-field": "{name:latin}\n{name:nonlatin}",
                "text-font": ["Metropolis Regular"],
                "text-justify": "left",
                "text-offset": [0.5, 0.2],
                "text-size": 10,
                "text-transform": "uppercase",
                "visibility": "visible"
            },
            "paint": {
                "icon-opacity": 0.7,
                "text-color": "rgb(101,101,101)",
                "text-halo-blur": 1,
                "text-halo-color": "rgba(0,0,0,0.7)",
                "text-halo-width": 1
            }
        },
        {
            "id": "place_city",
            "type": "symbol",
            "metadata": { "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f" },
            "source": "febase",
            "source-layer": "place",
            "minzoom": 7,
            "maxzoom": 14,
            "filter": ["all", ["==", "$type", "Point"], ["==", "class", "city"], [">", "rank", 3]],
            "layout": {
                "icon-image": {
                    "base": 1,
                    "stops": [
                        [0, "fe:circle-11"],
                        [9, ""]
                    ]
                },
                "icon-size": 0.4,
                "text-anchor": {
                    "base": 1,
                    "stops": [
                        [0, "left"],
                        [8, "center"]
                    ]
                },
                "text-field": "{name:latin}\n{name:nonlatin}",
                "text-font": ["Metropolis Regular"],
                "text-justify": "left",
                "text-offset": [0.5, 0.2],
                "text-size": 10,
                "text-transform": "uppercase",
                "visibility": "visible"
            },
            "paint": {
                "icon-opacity": 0.7,
                "text-color": "rgb(101,101,101)",
                "text-halo-blur": 1,
                "text-halo-color": "rgba(0,0,0,0.7)",
                "text-halo-width": 1
            }
        },
        {
            "id": "place_city_large",
            "type": "symbol",
            "metadata": { "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f" },
            "source": "febase",
            "source-layer": "place",
            "minzoom": 5,
            "maxzoom": 12,
            "filter": ["all", ["==", "$type", "Point"], ["<=", "rank", 3], ["==", "class", "city"]],
            "layout": {
                "icon-image": {
                    "base": 1,
                    "stops": [
                        [0, "fe:circle-11"],
                        [9, ""]
                    ]
                },
                "icon-size": 0.4,
                "text-anchor": {
                    "base": 1,
                    "stops": [
                        [0, "left"],
                        [8, "center"]
                    ]
                },
                "text-field": "{name:latin}\n{name:nonlatin}",
                "text-font": ["Metropolis Regular"],
                "text-justify": "left",
                "text-offset": [0.5, 0.2],
                "text-size": 14,
                "text-transform": "uppercase",
                "visibility": "visible"
            },
            "paint": {
                "icon-opacity": 0.7,
                "text-color": "rgb(101,101,101)",
                "text-halo-blur": 1,
                "text-halo-color": "rgba(0,0,0,0.7)",
                "text-halo-width": 1
            }
        },
        {
            "id": "place_state",
            "type": "symbol",
            "metadata": { "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f" },
            "source": "febase",
            "source-layer": "place",
            "minzoom": 5,
            "maxzoom": 12,
            "filter": ["all", ["==", "$type", "Point"], ["==", "class", "state"]],
            "layout": {
                "text-field": "{name:latin}\n{name:nonlatin}",
                "text-font": ["Metropolis Regular"],
                "text-size": 10,
                "text-transform": "uppercase",
                "visibility": "visible"
            },
            "paint": {
                "text-color": "rgb(101,101,101)",
                "text-halo-blur": 1,
                "text-halo-color": "rgba(0,0,0,0.7)",
                "text-halo-width": 1
            }
        },
        {
            "id": "place_country_other",
            "type": "symbol",
            "metadata": { "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f" },
            "source": "febase",
            "source-layer": "place",
            "maxzoom": 8,
            "filter": ["all", ["==", "$type", "Point"], ["==", "class", "country"], ["!has", "iso_a2"]],
            "layout": {
                "text-field": "{name:latin}",
                "text-font": ["Metropolis Light Italic"],
                "text-size": {
                    "base": 1,
                    "stops": [
                        [0, 9],
                        [1, 11]
                    ]
                },
                "text-transform": "uppercase",
                "visibility": "visible"
            },
            "paint": {
                "text-color": "rgb(101,101,101)",
                "text-halo-color": "rgba(0,0,0,0.7)",
                "text-halo-width": 1.4
            }
        },
        {
            "id": "place_country_minor",
            "type": "symbol",
            "metadata": { "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f" },
            "source": "febase",
            "source-layer": "place",
            "maxzoom": 8,
            "filter": ["all", ["==", "$type", "Point"], ["==", "class", "country"], [">=", "rank", 2], ["has", "iso_a2"]],
            "layout": {
                "text-field": "{name:latin}",
                "text-font": ["Metropolis Regular"],
                "text-size": {
                    "base": 1,
                    "stops": [
                        [0, 10],
                        [6, 12]
                    ]
                },
                "text-transform": "uppercase",
                "visibility": "visible"
            },
            "paint": {
                "text-color": "rgb(101,101,101)",
                "text-halo-color": "rgba(0,0,0,0.7)",
                "text-halo-width": 1.4
            }
        },
        {
            "id": "place_country_major",
            "type": "symbol",
            "metadata": { "mapbox:group": "101da9f13b64a08fa4b6ac1168e89e5f" },
            "source": "febase",
            "source-layer": "place",
            "maxzoom": 6,
            "filter": ["all", ["==", "$type", "Point"], ["<=", "rank", 1], ["==", "class", "country"], ["has", "iso_a2"]],
            "layout": {
                "text-anchor": "center",
                "text-field": "{name:latin}",
                "text-font": ["Metropolis Regular"],
                "text-size": {
                    "base": 1.4,
                    "stops": [
                        [0, 10],
                        [3, 12],
                        [4, 14]
                    ]
                },
                "text-transform": "uppercase",
                "visibility": "visible"
            },
            "paint": {
                "text-color": "rgb(101,101,101)",
                "text-halo-color": "rgba(0,0,0,0.7)",
                "text-halo-width": 1.4
            }
        },
        {
            "id": "aeroway-runway-name",
            "type": "symbol",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "aeroway",
            "minzoom": 13,
            "filter": ["all", ["==", "$type", "LineString"], ["==", "class", "runway"]],
            "layout": {
                "symbol-placement": "line",
                "symbol-spacing": 350,
                "text-field": "{ref}",
                "text-font": ["Metropolis Light"],
                "text-pitch-alignment": "viewport",
                "text-rotation-alignment": "viewport",
                "text-size": 10,
                "visibility": "visible"
            },
            "paint": { "text-color": "hsl(0, 0%, 37%)", "text-translate": [0, 2] }
        },
        {
            "id": "aeroway-taxiway-name",
            "type": "symbol",
            "metadata": { "mapbox:group": "b6371a3f2f5a9932464fa3867530a2e5" },
            "source": "febase",
            "source-layer": "aeroway",
            "minzoom": 13,
            "filter": ["all", ["==", "$type", "LineString"], ["==", "class", "taxiway"]],
            "layout": {
                "symbol-placement": "line",
                "symbol-spacing": 250,
                "text-field": "{ref}",
                "text-font": ["Metropolis Light"],
                "text-pitch-alignment": "viewport",
                "text-rotation-alignment": "viewport",
                "text-size": 10,
                "visibility": "visible"
            },
            "paint": { "text-color": "hsl(0, 0%, 37%)", "text-translate": [0, 2] }
        },
        {
            "id": "airport-gate",
            "type": "symbol",
            "source": "febase",
            "source-layer": "aeroway",
            "minzoom": 15,
            "filter": ["==", "class", "gate"],
            "layout": {
                "symbol-spacing": 10,
                "text-field": "{ref}",
                "text-font": ["Noto Sans Regular"],
                "text-rotation-alignment": "viewport",
                "text-size": 10
            },
            "paint": { "text-color": "hsl(0, 0%, 37%)", "text-translate": [0, 2] }
        }
    ],
    "id": "FE-Dark"
}
